var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-height" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            top: "2%",
            "append-to-body": "",
            title: "領隊資料檢視",
            visible: _vm.dialogLeaderViewVisible,
            width: "70%",
          },
          on: {
            opened: _vm.leaderViewOpenedHandle,
            "update:visible": function ($event) {
              _vm.dialogLeaderViewVisible = $event
            },
          },
        },
        [
          _vm.dialogLeaderViewVisible
            ? _c("leader-data", {
                staticStyle: {
                  height: "calc(100vh - 210px)",
                  "overflow-y": "auto",
                },
                attrs: { userID: parseInt(_vm.selectedLeaderUserID) },
              })
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogLeaderViewVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.formLoading,
              expression: "formLoading",
            },
          ],
          attrs: {
            top: "3vh",
            title: "領隊資料維護",
            visible: _vm.dialogFormVisible,
            "append-to-body": "",
            width: _vm.isAdd ? "30%" : "70%",
            "show-close": "",
          },
          on: {
            closed: _vm.onDialogClosed,
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.isAdd ? 24 : 13 } },
                [
                  _c("el-card", { staticClass: "box-card" }, [
                    _c(
                      "div",
                      {
                        staticClass: "clearfix",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("el-alert", {
                          staticStyle: { color: "#4b4b4b" },
                          attrs: {
                            title: "預設密碼為西元生日，ex:19880101",
                            type: "warning",
                            effect: "dark",
                            closable: false,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "leader-data" },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "dynamicValidateForm",
                            attrs: {
                              model: _vm.formData,
                              disabled: !_vm.authEdit && !_vm.isAdd,
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "所屬旅行社",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "agencyCode",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.agencyCode ? true : false,
                                      filterable: "",
                                      placeholder: "請選擇",
                                    },
                                    model: {
                                      value: _vm.formData.agencyCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "agencyCode",
                                          $$v
                                        )
                                      },
                                      expression: "formData.agencyCode",
                                    },
                                  },
                                  _vm._l(_vm.agencyList, function (item) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.val,
                                        value: item.key,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "領隊姓名",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "name",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請輸入領隊姓名",
                                      trigger: "blur",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { autocomplete: "off" },
                                  model: {
                                    value: _vm.formData.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "name", $$v)
                                    },
                                    expression: "formData.name",
                                  },
                                }),
                              ],
                              1
                            ),
                            !_vm.isAdd
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "領隊暱稱",
                                      "label-width": _vm.formLabelWidth,
                                      prop: "name",
                                      rules: [
                                        {
                                          required: true,
                                          message: "請輸入領隊暱稱",
                                          trigger: "blur",
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { autocomplete: "off" },
                                      model: {
                                        value: _vm.formData.nickName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "nickName",
                                            $$v
                                          )
                                        },
                                        expression: "formData.nickName",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "領隊生日",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "birthday",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請輸入領隊生日",
                                      trigger: "blur",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "date",
                                    placeholder: "請選擇領隊生日",
                                    format: "yyyy-MM-dd",
                                    "value-format": "yyyy-MM-dd",
                                  },
                                  model: {
                                    value: _vm.formData.birthday,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "birthday", $$v)
                                    },
                                    expression: "formData.birthday",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "領隊電話",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "mobile",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請輸入領隊電話",
                                      trigger: "blur",
                                    },
                                    {
                                      required: true,
                                      pattern: _vm.pattern.mobile,
                                      message: "電話格式不正確",
                                      trigger: "blur",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { autocomplete: "off" },
                                  model: {
                                    value: _vm.formData.mobile,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "mobile", $$v)
                                    },
                                    expression: "formData.mobile",
                                  },
                                }),
                              ],
                              1
                            ),
                            !_vm.isAdd
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "領隊介紹",
                                      "label-width": _vm.formLabelWidth,
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "textarea", rows: 3 },
                                      model: {
                                        value: _vm.formData.selfDescription,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "selfDescription",
                                            $$v
                                          )
                                        },
                                        expression: "formData.selfDescription",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            !_vm.isAdd
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "領隊經歷",
                                      "label-width": _vm.formLabelWidth,
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "textarea", rows: 3 },
                                      model: {
                                        value: _vm.formData.experience,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "experience",
                                            $$v
                                          )
                                        },
                                        expression: "formData.experience",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            !_vm.isAdd
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "證照說明",
                                      "label-width": _vm.formLabelWidth,
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "textarea", rows: 3 },
                                      model: {
                                        value: _vm.formData.certificatesRemark,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "certificatesRemark",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.certificatesRemark",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            !_vm.isAdd
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "專長",
                                      "label-width": _vm.formLabelWidth,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          multiple: "",
                                          filterable: "",
                                          "allow-create": "",
                                          "default-first-option": "",
                                          placeholder: "請選擇或輸入專長",
                                        },
                                        model: {
                                          value: _vm.formData.specialties,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "specialties",
                                              $$v
                                            )
                                          },
                                          expression: "formData.specialties",
                                        },
                                      },
                                      _vm._l(
                                        _vm.specialtyOptions,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            !_vm.isAdd
                              ? [
                                  _c(
                                    "el-divider",
                                    { attrs: { "content-position": "left" } },
                                    [_vm._v("履歷隱私與邀約")]
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "公開履歷",
                                        "label-width": _vm.formLabelWidth,
                                      },
                                    },
                                    [
                                      _c("el-switch", {
                                        model: {
                                          value:
                                            _vm.formData.privacy
                                              .isProfilePublic,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData.privacy,
                                              "isProfilePublic",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.privacy.isProfilePublic",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "接受邀約",
                                        "label-width": _vm.formLabelWidth,
                                      },
                                    },
                                    [
                                      _c("el-switch", {
                                        model: {
                                          value:
                                            _vm.formData.privacy
                                              .acceptInvitations,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData.privacy,
                                              "acceptInvitations",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.privacy.acceptInvitations",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "公開年齡",
                                        "label-width": _vm.formLabelWidth,
                                      },
                                    },
                                    [
                                      _c("el-switch", {
                                        model: {
                                          value: _vm.formData.privacy.showAge,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData.privacy,
                                              "showAge",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.privacy.showAge",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "公開居住地",
                                        "label-width": _vm.formLabelWidth,
                                      },
                                    },
                                    [
                                      _c("el-switch", {
                                        model: {
                                          value:
                                            _vm.formData.privacy.showResidence,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData.privacy,
                                              "showResidence",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.privacy.showResidence",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              !_vm.isAdd
                ? _c(
                    "el-col",
                    { attrs: { offset: 1, span: 10 } },
                    [
                      _c(
                        "el-card",
                        { staticClass: "box-card" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "clearfix",
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [_c("span", [_vm._v("頭像")])]
                          ),
                          _c("Upload", {
                            ref: "uploadAvatar",
                            attrs: {
                              accept: ".jpg,.jpeg,.png,.webp",
                              "data-obj": _vm.fileObj,
                              "use-drag": false,
                              action: "Agency",
                              "auto-upload": false,
                              multiple: false,
                              "limit-file-count": 1,
                              "show-file-list": true,
                              "form-on-loading-parent": _vm.formOnLoading,
                              "btn-txt": "選擇頭像",
                              "before-file-list": _vm.formData.avatar,
                              "show-limit": false,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isAdd
                ? _c(
                    "el-col",
                    { attrs: { offset: 1, span: 10 } },
                    [
                      _c("el-card", { staticClass: "box-card" }, [
                        _c(
                          "div",
                          {
                            staticClass: "clearfix",
                            attrs: { slot: "header" },
                            slot: "header",
                          },
                          [_c("span", [_vm._v("領隊照片")])]
                        ),
                        _c(
                          "div",
                          [
                            _c("Upload", {
                              ref: "upload1",
                              attrs: {
                                accept: ".jpg,.jpeg,.png",
                                "data-obj": _vm.fileObj,
                                "use-drag": false,
                                action: "Agency",
                                "auto-upload": false,
                                "show-file-list": true,
                                "form-on-loading-parent": _vm.formOnLoading,
                                "btn-txt": "上傳",
                                "before-file-list": _vm.formData.file1,
                                "show-limit": false,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isAdd
                ? _c(
                    "el-col",
                    {
                      staticStyle: { "margin-top": "20px" },
                      attrs: { offset: 1, span: 10 },
                    },
                    [
                      _c("el-card", { staticClass: "box-card" }, [
                        _c(
                          "div",
                          {
                            staticClass: "clearfix",
                            attrs: { slot: "header" },
                            slot: "header",
                          },
                          [_c("span", [_vm._v("相關證照")])]
                        ),
                        _c(
                          "div",
                          [
                            _c("Upload", {
                              ref: "upload2",
                              attrs: {
                                "data-obj": _vm.fileObj,
                                accept: ".jpg,.jpeg,.png",
                                "use-drag": false,
                                action: "Agency",
                                "auto-upload": false,
                                "show-file-list": true,
                                "form-on-loading-parent": _vm.formOnLoading,
                                "btn-txt": "上傳",
                                "before-file-list": _vm.formData.file2,
                                "show-limit": false,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.isAdd || _vm.authEdit
                ? _c(
                    "el-button",
                    {
                      staticStyle: { color: "#4b4b4b" },
                      attrs: { type: "warning" },
                      on: {
                        click: function ($event) {
                          return _vm.saveData("dynamicValidateForm")
                        },
                      },
                    },
                    [_vm._v("儲 存")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: _vm.isAdd || _vm.authEdit ? "" : "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.isAdd || _vm.authEdit ? "取 消" : "關 閉"))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "filter-form",
          attrs: { inline: true },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "查詢" } },
            [
              _c("el-input", {
                attrs: { placeholder: "輸入旅行社代碼/領隊暱稱/領隊姓名" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.getList($event)
                  },
                },
                model: {
                  value: _vm.listQuery.qry,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "qry", $$v)
                  },
                  expression: "listQuery.qry",
                },
              }),
            ],
            1
          ),
          _c("el-button", {
            staticStyle: { "margin-top": "8px", "margin-left": "5px" },
            attrs: {
              type: "primary",
              icon: "el-icon-search",
              circle: "",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.getList },
          }),
          _c("el-button", {
            attrs: {
              type: "warning",
              circle: "",
              icon: "el-icon-plus",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.addData },
          }),
          _c("el-button", {
            staticStyle: { cursor: "pointer" },
            attrs: {
              type: "success",
              loading: _vm.listLoading,
              circle: "",
              icon: "el-icon-refresh-left",
            },
            on: {
              click: function ($event) {
                return _vm.refresh()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "formDetailsTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
              on: { "sort-change": _vm.sortChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "數量",
                  width: "1",
                  type: "expand",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              size: "mini",
                              data: scope.row.travels,
                              border: "",
                              height: "200",
                              "row-class-name": _vm.tableRowClassName,
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "",
                                "min-width": 50,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return scope.row.beginDateTime1
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "14px",
                                                  "text-align": "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.travelName1)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-tag",
                                                  { attrs: { size: "mini" } },
                                                  [
                                                    _vm._v(" 出發 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "red",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            "" +
                                                              scope.row
                                                                .beginDateTime1
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" - 回程 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "red",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            "" +
                                                              scope.row
                                                                .endDateTime1
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        : undefined
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "",
                                "min-width": 50,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return scope.row.beginDateTime2
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "14px",
                                                  "text-align": "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.travelName2)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-tag",
                                                  { attrs: { size: "mini" } },
                                                  [
                                                    _vm._v(" 出發 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "red",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            "" +
                                                              scope.row
                                                                .beginDateTime2
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" - 回程 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "red",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            "" +
                                                              scope.row
                                                                .endDateTime2
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        : undefined
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "手機號碼", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.mobile))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "領隊姓名", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.name))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "領隊暱稱", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.nickName))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "查看", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: _vm.checkPermission([
                                "ITA-DEV",
                                "ITA-ADMIN",
                                "ITA-ADM-STAFF",
                              ])
                                ? "success"
                                : "info",
                              size: "mini",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.checkPermission([
                                    "ITA-DEV",
                                    "ITA-ADMIN",
                                    "ITA-ADM-STAFF",
                                  ])
                                    ? "編輯"
                                    : "查看"
                                )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "出團數", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticStyle: {
                              "font-size": "15px",
                              "font-weight": "bold",
                              cursor: "pointer",
                            },
                            attrs: { type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.toogleExpand(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.toursCount) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "滿意度",
                  width: "120",
                  sortable: "",
                  prop: "satisfactionAnalysis",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.satisfaction.satisfactionAnalysis
                          ? _c(
                              "el-tag",
                              {
                                staticStyle: {
                                  "font-size": "20px",
                                  "font-weight": "bold",
                                },
                                attrs: {
                                  type: _vm.getSatisfactionAnalysisStyle(
                                    scope.row.satisfaction.satisfactionAnalysis
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.satisfaction.satisfactionAnalysis
                                  ) +
                                    " (" +
                                    _vm._s(
                                      scope.row.satisfaction.travelersCount
                                    ) +
                                    ") "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }